/**
 * Open a new window with pdf
 */
export function openPdf(response, type = 'application/pdf') {
  const file = new Blob([response], { type });
  if (
    navigator.appVersion.toString().indexOf('.NET') > 0 ||
    navigator.appVersion.toString().indexOf('Edge') > 0
  ) {
    const extension = type.split('/')[1];
    window.navigator.msSaveBlob(
      file,
      `${URL.createObjectURL(file)}.${extension}`
    );
  } else {
    const popUp = window.open(URL.createObjectURL(file), '_blank');
    if (!popUp || typeof popUp === 'undefined') {
      alert('Blocked popup'); // eslint-disable-line
    } else {
      popUp.focus();
    }
  }
}

/**
 * Return a object with error
 * @return object
 */
export function catchPdf(response) {
  const decodedString = String.fromCharCode.apply(
    null,
    new Uint8Array(response)
  );
  const obj = JSON.parse(decodedString);
  return obj.message;
}

/**
 * Force download files
 */
export function downloadFile(data, name = 'download') {
  const link = document.createElement('a');
  link.setAttribute('href', data);
  link.setAttribute('download', name);
  link.click();
}

/**
 * Check file name and generate
 */
export function getFileName(name, extension = 'txt') {
  if (!name) {
    const date = new Date().toLocaleString('pt-BR').replace(' ', '_');
    return `Relatório-${date}.${extension}`;
  }
  return name;
}

/**
 * Force download csv files
 */
export function downloadCsvFile(response, name = null) {
  const filename = getFileName(name, 'csv');
  const blob = new Blob(['\uFEFF'.concat(response)], { type: 'text/csv;charset=UTF-8;' });
  const data = URL.createObjectURL(blob);

  downloadFile(data, filename);
}

/**
 * Force download word files
 */
export function downloadWordFile(response, name = null) {
  const blob = new Blob([response], {
    type: 'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  });
  const filename = getFileName(name, 'docx');
  downloadFile(URL.createObjectURL(blob), filename);
}
